// @mui
import {
  TableRow,
  TableCell,
  Typography,
  Grid,
  Card,
  Table,
  TableBody,
  TableContainer,
  Paper,
  Button,
  Stack,
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

// Localization
import useLocales from 'src/hooks/useLocales';
import Label from 'src/components/Label';

// Store & MobX
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores/store';

// API
import { baseUrl } from 'src/api/baseUrl';
import { Incomes } from 'src/@types/Choqorak/MainTables/Income/Income';
import { DateConverter } from 'src/sections/common/DateConverter';
import Iconify from 'src/components/Iconify';
import { PATH_DASHBOARD } from 'src/routes/paths';
import { useNavigate } from 'react-router';

// Types


type Props = {
  row?: Incomes;
};

export default observer(function IncomeDetailTableRow({ row }: Props) {
  const { translate } = useLocales();
  const { IncomeStore } = useStore();
  const { selectedIncomeDetail } = IncomeStore;
  const Url = baseUrl;
  const navigate = useNavigate();
  return (
    <>
      {/* Main Details */}
      {/* <Grid item xs={6} md={6}>
       
      </Grid> */}
      <Grid item xs={12} md={12} sx={{ padding: '50px' }}>
        <Stack direction="row" spacing={1.5} sx={{ mt: 1, ml: 0, mb: 2 }}>
          <Button
            variant="contained"
            color="error"
            size="small"
            startIcon={<Iconify icon="eva:arrow-ios-back-fill" />}
            onClick={() => {
              navigate(PATH_DASHBOARD.Income.list);
              // clearCustomer();
            }}
          >
            {translate('CRUD.BackToList')}
          </Button>
        </Stack>
        <Card sx={{ p: 2 }}>
          <Typography
            variant="h5"
            sx={{ fontSize: 14, textAlign: 'center', mb: 2, color: 'warning.main' }}
            color="text.secondary"
            gutterBottom
          >
            <Label
              variant="ghost"
              sx={{ textTransform: 'capitalize', fontSize: 15, p: 2 }}
              color="warning"
            >
              {translate('Income.Title')} {translate('CRUD.Detail')}
            </Label>
          </Typography>

          <TableContainer component={Paper}>
            <Table sx={{ minWidth: '100%' }} size="small">
              <TableBody>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', color: 'info.main', fontSize: '16px' }}>
                    {translate('IncomeCategory.IncomeCategory')}
                  </TableCell>
                  <TableCell>{selectedIncomeDetail?.incomeCategory}</TableCell>

                  <TableCell sx={{ fontWeight: 'bold', color: 'info.main', fontSize: '16px' }}>
                    {translate('Income.Amount')}
                  </TableCell>
                  <TableCell>{selectedIncomeDetail?.amount}</TableCell>

                  <TableCell sx={{ fontWeight: 'bold', color: 'info.main', fontSize: '16px' }}>
                    {translate('Income.Currency')}
                  </TableCell>
                  <TableCell>{selectedIncomeDetail?.carrencyType}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', color: 'info.main', fontSize: '16px' }}>
                    {translate('Income.Date')}
                  </TableCell>
                  <TableCell>{<DateConverter date={selectedIncomeDetail?.recieveDate} />}</TableCell>

                  <TableCell sx={{ fontWeight: 'bold', color: 'info.main', fontSize: '16px' }}>
                    {translate('RentPaymentPrint.SerialNumber')}
                  </TableCell>
                  <TableCell>{selectedIncomeDetail?.serialNumber}</TableCell>

                  <TableCell sx={{ fontWeight: 'bold', color: 'info.main', fontSize: '16px' }}>
                    {translate('Income.Description')}
                  </TableCell>
                  <TableCell>{selectedIncomeDetail?.description}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      </Grid>

      {/* Attachments */}
      {selectedIncomeDetail?.attachmentFiles?.length ? (
        <Grid item xs={12} md={12} sx={{ padding: '50px' }}>
          <Card sx={{ p: 2 }}>
            <Typography
              variant="h5"
              sx={{ fontSize: 14, textAlign: 'center', mb: 2, color: 'warning.main' }}
              color="text.secondary"
              gutterBottom
            >
              <Label
                variant="ghost"
                sx={{ textTransform: 'capitalize', fontSize: 15, p: 2 }}
                color="warning"
              >
                {translate('contractsInfo.Attachments')}
              </Label>
            </Typography>

            <TableContainer component={Paper}>
              <Table size="small">
                <TableBody>
                  {selectedIncomeDetail.attachmentFiles?.map((file, index) => (
                    <TableRow key={index}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{file.fileName}</TableCell>
                      <TableCell>
                        <a
                          href={Url + file.path}
                          style={{ color: 'orange' }}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <DownloadIcon />
                        </a>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Grid>
      ) : null}
    </>
  );
});
